/* eslint-disable */
import cx from 'classnames';
import moment from 'moment';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch, distance } from '../../utils/util';
import { compose, withProps, withState, withHandlers, lifecycle  } from "recompose";
import { withGoogleMap, withScriptjs, GoogleMap, Marker, InfoWindow } from 'react-google-maps'
import { MAP } from 'react-google-maps/lib/constants';
import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer';
const { MarkerWithLabel } = require("react-google-maps/lib/components/addons/MarkerWithLabel");
import Highlighter from "react-highlight-words";

import './EscapeMap.css';
import EscapeForm from './EscapeForm';
import EscapeAdder from './EscapeAdder';
import ReviewForm from './ReviewForm';
import ReviewItem from './ReviewItem';
import { Escape } from './EscapeList';

import {
} from '../../actions';


const clusteringZoomCutoff = 10;

const MapWithControlledZoom = compose(
  withProps({
  }),
  withState('zoom', 'onZoomChange', 8),
  withHandlers(() => {
    const refs = {
      map: undefined,
    };

    let timeoutId = null;
    let didInit = false;

    return {
      onMapMounted: ({ onBoundsChanged }) => (ref, escapes) => {
        refs.map = ref;
        setTimeout(
          () => {
            if (didInit) return;
            didInit = true;

            console.log('init bounds!', refs.map.getBounds());
            console.log('map fit bounds?', refs.map.fitBounds);
            console.log('map fit bounds?', google.maps);

            let markers = [];
            var bounds = new google.maps.LatLngBounds();
            for (let escape of escapes) {
              if (!escape.room.location) continue;
              let lat = escape.room.location.lat;
              let lng = escape.room.location.lng;
              if (!lat || !lng) continue;
              lat = parseFloat(lat);
              lng = parseFloat(lng);
              let pos = { lat, lng };
              bounds.extend(pos);
            }
            console.log('refs.map', refs.map.context[MAP].setOptions);
            refs.map.context[MAP].setOptions({ disableDefaultUI: true });
            refs.map.context[MAP].setOptions({ zoomControl: true });
            refs.map.fitBounds(bounds);
            onBoundsChanged(refs.map.getBounds(), refs.map.getCenter(), true);
          },
          100);
      },
      onToggleOpen: ({ onToggleOpen }) => (escape) => {
        onToggleOpen(escape);
      },
      onZoomChanged: ({ onZoomChange }) => () => {
        onZoomChange(refs.map.getZoom())
      },
      onCenterChanged: ({ onCenterChanged }) => () => {
        onCenterChanged(refs.map.getCenter());
      },
      onBoundsChanged: ({ onBoundsChanged }) => () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        // onBoundsChanged(refs.map.getBounds(), refs.map.getCenter(), false);
        timeoutId = setTimeout(
          () => { onBoundsChanged(refs.map.getBounds(), refs.map.getCenter(), true) },
          500,
        );
      },
    }
  }),
  withGoogleMap
)(props => {
  if (!props.escapes) return null;

  let escapes = [];
  for (let escape of props.escapes) {
    if (!escape.room.location ||
        !escape.room.location.lat ||
        !escape.room.location.lng)
    {
      continue;
    }

    escapes.push(escape);
  }

  escapes = escapes.sort((a, b) => a.id - b.id);

  let defaultLat = 37.3861;
  let defaultLng = -122.0839;

  let assignedToGroup = {};
  let groupWithin = 0.1; // miles

  let nextGroupId = 1;
  for (let e1 of escapes) {
    for (let e2 of escapes) {
      if (assignedToGroup[e2.id]) continue;

      let l1 = e1.room.location;
      let l2 = e2.room.location;

      let d = distance(l1.lat, l1.lng, l2.lat, l2.lng);

      if (d > groupWithin) continue;

      let targetGroupId = null;

      if (assignedToGroup[e1.id]) {
        targetGroupId = assignedToGroup[e1.id];
      } else {
        targetGroupId = nextGroupId++;
      }

      assignedToGroup[e1.id] = nextGroupId;
      assignedToGroup[e2.id] = nextGroupId;
    }
  }

  console.log('ddd assigned to groups:', assignedToGroup);
  
  let groups = {};
  for (let escapeId of Object.keys(assignedToGroup)) {
    let groupId = assignedToGroup[escapeId];
    if (!groups[groupId]) {
      groups[groupId] = [];
    }
    for (let escape of escapes) {
      if (escape.id == escapeId) {
        groups[groupId].push(escape);
      }
    }
  }

  console.log('ddd groups:', groups);

  // console.log('ddd google.maps', google.maps);

  let zIndex = 1;

  let groupIds = Object.keys(groups);
  groupIds = groupIds.sort((a, b) => {
    return groups[b][0].room.location.lat - groups[a][0].room.location.lat
  });

  let nodes = groupIds.map(groupId => {
    let groupedEscapes = groups[groupId];

    let escapeNodes = groupedEscapes.map(escape => {
      return (
        <Escape key={escape.id} escape={escape} />
      );
    });

    let lat = parseFloat(groupedEscapes[0].room.location.lat);
    let lng = parseFloat(groupedEscapes[0].room.location.lng);
    defaultLat = lat;
    defaultLng = lng;
    let pos = { lat, lng };
    let onToggleOpen = () => {
      props.onToggleOpen({ id: groupId });
    };

    console.log('ddd open?', props.open, groupId);
    let isOpen = props.open && props.open.id == groupId;

    let info = null;
    if (isOpen) {
      info = (
        <InfoWindow onCloseClick={props.onToggleClose}>
          <div className="map-marker-escape">
            {escapeNodes}
          </div>
        </InfoWindow>
      );
    }

    let labelNode;
    if (isOpen) {
      labelNode = (
        <div className="map-marker-escape">
          {escapeNodes}
        </div>
      );
    } else if (groupedEscapes.length == 1) {
      labelNode = groupedEscapes[0].room.name;
    } else {
      let companies = {};
      for (let escape of groupedEscapes) {
        companies[escape.room.location.company] = true;
      }
      let companyNames = Object.keys(companies);
      console.log('ddd companyNames', companyNames)
      labelNode = companyNames.join(', ') + ' (' + groupedEscapes.length + ')' ;
    }

    // let zIndex = 10;
    let useZIndex = zIndex++;
    if (isOpen) {
      useZIndex = 100000
    }
    
    return (
      <MarkerWithLabel
        key={escape.id}
        position={pos}
        labelAnchor={new google.maps.Point(0, 0)}
        labelClass={cx('escape-marker-label', { open: isOpen })}
        labelStyle={{}}
        onClick={() => onToggleOpen()}
        zIndex={useZIndex}
      >
        <div className="label-inner">
          {labelNode}
        </div>
      </MarkerWithLabel>
    );

    return (
      <Marker
        key={escape.id}
        position={pos}
        onClick={() => onToggleOpen()}
      >
        {isOpen && info}
      </Marker>
    );
  });

  console.log('fit props', props)

  if (props.zoom < clusteringZoomCutoff) {
    nodes = (
      <MarkerClusterer
        averageCenter
        enableRetinaIcons
        gridSize={50}
        onClick={props.onMarkerClustererClick}
        maxZoom={clusteringZoomCutoff}
        zoomOnClick={true}
        >
        {nodes}
      </MarkerClusterer>
    );
  }

  return (
    <div>
      <GoogleMap
        defaultZoom={4}
        defaultCenter={{ lat: defaultLat, lng: defaultLng }}
        ref={(ref) => props.onMapMounted(ref, props.escapes)}
        refold={props.onMapMounted}
        onZoomChanged={props.onZoomChanged}
        onCenterChanged={props.onCenterChanged}
        onBoundsChanged={props.onBoundsChanged}
        clickableIcons={false}
      >
        {nodes}
      </GoogleMap>
    </div>
  );
});


class EscapeMap extends Component {

  state = {
  };

  boundsChanged(bounds, center) {
  }

  centerChanged(center) {
  }

  toggleOpen(escape) {
    console.log('Toggle open', escape);
    if (this.state.open && this.state.open.id == escape.id) {
      this.setState({ open: null });
    } else {
      this.setState({ open: escape });
    }
  }

  cluster(c) {
    return;

    console.log('CLICKED CLUSTER', c, c.getCenter(), c.getMap());
    c.getMap().setCenter(c.getMarkers()[0].getPosition());
    setTimeout(() => c.getMap().setZoom(clusteringZoomCutoff), 100);
  }

  render() {
    let height;
    let width;
    if (this.props.mapSize == 'small') {
      height = '300px';
      width = '300px';
    } else if (this.props.mapSize == 'full') {
      height = '100vh';
      width = '100vw';
    } else {
      height = '500px';
      width = '100%';
    }

    return (
      <div className="EscapeMap">
        <div className="map-wrapper">
          <MapWithControlledZoom
            isMarkerShown
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: height, width: width }} />}
            mapElement={<div style={{ height: `100%` }} />}
            onCenterChanged={(center) => this.centerChanged(center)}
            onBoundsChanged={(bounds, center, shouldUpdate) => this.boundsChanged(bounds, center, shouldUpdate)}
            onToggleOpen={(escape) => this.toggleOpen(escape)}
            onZoomChange={(zoom) => this.setState({ zoom })}
            onMarkerClustererClick={(c) => this.cluster(c)}
            open={this.state.open}
            zoom={this.state.zoom}
            {...this.props}
            >
          </MapWithControlledZoom>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EscapeMap);



/** WEBPACK FOOTER **
 ** ./src/components/partials/EscapeMap.js
 **/